/* import Announcement from '@/shared/http/repositories/realestate/announcementRepository' */
import ActionsForm from '@/shared/mixins/actionsForm'
import AutocompleteZ from '@/components/forms/AutocompleteZ'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpenses/mixins/ExpenseMixin.js'
import Announcement from '@/shared/http/repositories/realestate/announcementRepository'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
export default {
  mixins: [ActionsForm, ExpenseMixin],
  name: 'searchAnnouncements',
  components: {
    AutocompleteZ
  },
  data () {
    return {
      title: 'Buscar por Comunicado',
      searchArrayAnnouncements: null,
      empreend: null,
      tipoDestino: 0,
      empreendimento: [],
      SearchDados: {
        comunicadoId: null,
        empreendimentoId: null,
        dataInicio: '',
        dataFim: '',
        aplicativo: null,
        destino: null,
        tipoPesquisa: null,
        comunicado: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        }
      },
      aplicativos: [
        {value: null, text: 'Todos os Aplicativos'},
        {value: 0, text: 'ZCorretor'},
        {value: 1, text: 'Zincorporação Morador'}
      ]
    }
  },
  methods: {
    onLoad () {
    /*       Announcement.GetSearchEmpreendimento()
        .then(Response => {
          this.empreend = Response.data.data
        })
        .catch(() => {}) */
      Announcement.GetSearchEmpreendimento()
        .then((res) => {
          let stateCompleteData = res.data.data
          console.log(res)
          stateCompleteData.forEach(stateData => {
            this.empreendimento.push({value: stateData.empreendimento.id, text: stateData.empreendimento.nome})
          })
        })
        .catch(() => {})
    },
    changeDestination () {
      if (this.SearchDados.empreendimentoId === null) {
        this.SearchDados.destino = 0
        this.SearchDados.empreendimentoId = 'none'
      }
      if (this.SearchDados.empreendimentoId === 'none') {
        this.SearchDados.destino = 1
        this.SearchDados.empreendimentoId = null
      }
    },
    Search () {
      this.SearchDados.comunicadoId = this.SearchDados.comunicado.value
      var today = new Date()
      if (this.SearchDados.dataInicio !== '' && this.SearchDados.dataFim === '') {
        this.SearchDados.dataFim = today
      }
      this.$emit('SearchDados', this.SearchDados, true)
      localStoreHelper.gestao.comunicados(this.SearchDados)
    },

    Clear () {
      this.$refs.ComunicadoTypeahead.clear()
      Object.keys(this.SearchDados).forEach(prop => {
        if (prop === 'comunicado') {
          this.SearchDados[prop].value = null
        } else {
          this.SearchDados[prop] = null
        }
      })
      this.$emit('SearchDados', this.SearchDados, false)
      localStoreHelper.gestao.comunicados(null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/announcements/components/searchAnnouncements/searchAnnouncements.js